import type {
    MODAL_RETAILER_DEBUG,
    RetailerDebugModalType,
} from "../../../shared-logic/features/retailer/utils/modalConstants";
import type {
    ContactDealerType,
    MODAL_USC_FORM,
} from "../../shared-logic/utils/integrated-modal/integratedModalConstants";
import type { UscBasketDetailsModalType } from "../components/toyota/modals/UscBasketDetailsModal";
import type { UscDiscoverYourCarType } from "../components/toyota/modals/DiscoverYourCarModal";
import type { UscMobileNavCta } from "../components/toyota/modals/MobileNavCtaModal";
import type {
    MODAL_USC_INJECTION,
    MODAL_VEHICLE_FOR_SALE_ID,
    UscInjectionModalType,
    VehicleForSaleIdModalType,
} from "../../shared-logic/utils/modalConstants";
import type { UscVehicleSaleType } from "../../shared-logic/types/UscCommonTypes";
import type { MODAL_TYRE_INFO, TyreInfoModalType } from "../../../shared-logic/utils/tyreInfoContants";

export const MODAL_USC_MOBILE_NAV_CTA = "uscMobileNavCta";
export const MODAL_USC_BASKET_DETAILS = "uscBasketDetails";
export const MODAL_USC_DISCOVER_YOUR_CAR = "uscDiscoverYourCar";
export const MODAL_USC_DEBUG = "uscDebug";
export const MODAL_USC_THREE_SIXY_SPIN = "uscThreeSixySpin";
export const MODAL_USC_CAR_DELIVERY = "uscCarDelivery";
export const MODAL_USC_CAR_DELIVERY_INFO = "uscCarDeliveryInfo";
export const MODAL_USC_VEHICLE_SALE_TYPE = "uscVehicleSaleType";

export type UscDebugModalType = {
    type: typeof MODAL_USC_DEBUG;
};
export type UscThreeSixtySpinModalType = {
    type: typeof MODAL_USC_THREE_SIXY_SPIN;
};
export type UscCarDeliveryModalType = {
    type: typeof MODAL_USC_CAR_DELIVERY;
};
export type UscCarDeliveryInfoModalType = {
    type: typeof MODAL_USC_CAR_DELIVERY_INFO;
};
export type UscVehicleSaleTypeModalType = {
    type: typeof MODAL_USC_VEHICLE_SALE_TYPE;
    vehicleSaleType: UscVehicleSaleType;
};

export type UscModalIdsType =
    | typeof MODAL_TYRE_INFO
    | typeof MODAL_USC_FORM
    | typeof MODAL_USC_MOBILE_NAV_CTA
    | typeof MODAL_USC_DEBUG
    | typeof MODAL_USC_THREE_SIXY_SPIN
    | typeof MODAL_RETAILER_DEBUG
    | typeof MODAL_USC_CAR_DELIVERY_INFO
    | typeof MODAL_USC_CAR_DELIVERY
    | typeof MODAL_USC_BASKET_DETAILS
    | typeof MODAL_USC_DISCOVER_YOUR_CAR
    | typeof MODAL_USC_VEHICLE_SALE_TYPE
    | typeof MODAL_USC_INJECTION
    | typeof MODAL_VEHICLE_FOR_SALE_ID;

export type UscModalsType =
    | TyreInfoModalType
    | ContactDealerType
    | UscMobileNavCta
    | UscDebugModalType
    | UscThreeSixtySpinModalType
    | RetailerDebugModalType
    | UscCarDeliveryInfoModalType
    | UscCarDeliveryModalType
    | UscBasketDetailsModalType
    | UscDiscoverYourCarType
    | UscVehicleSaleTypeModalType
    | VehicleForSaleIdModalType
    | UscInjectionModalType;
